import { API_GATEWAY_BASE_URLS } from './config';

export const environment = {
  name: 'uat' as const,
  production: true,
  apiGatewayBaseUrl: API_GATEWAY_BASE_URLS.uat,
};
